module.exports = __webpack_public_path__ + "static/media/ministryofcoin_logo_light.10ecc295.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/ministryofcoin_logo_light.svg
// module id = 900
// module chunks = 0